import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  indexOfAny2ijjuuzpljsyd as indexOfAny,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  substringBefore3n7kj60w69hju as substringBefore,
  contains2el4s70rdq4ld as contains,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Companion_getInstance2vzevs5m6d283 as Companion_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { substringiqarkczpya5m as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Companion_getInstance3p275ab8rhrps as Companion_getInstance_0 } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/UtcOffset.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance_1,
  offsetAtp6wlf8rffh6g as offsetAt,
  toInstant2lllz720612kd as toInstant,
  FixedOffsetTimeZone3oldrgkltiv4z as FixedOffsetTimeZone,
  toInstant2q17i3aluy6ks as toInstant_0,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from './DefaultClock.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      xw(string) {
        // Inline function 'kotlin.charArrayOf' call
        var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(90), _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(43), _Char___init__impl__6a9atx(45)]);
        var dateTimeFinishedIndex = indexOfAny(string, tmp$ret$0, 14);
        if (dateTimeFinishedIndex === -1)
          dateTimeFinishedIndex = string.length;
        var tmp = Companion_getInstance().q25(substring(string, 0, dateTimeFinishedIndex));
        var tmp_0;
        if (dateTimeFinishedIndex === string.length) {
          tmp_0 = Companion_getInstance_0().i26_1;
        } else if (contains(string, _Char___init__impl__6a9atx(91))) {
          var tmp_1 = Companion_getInstance_1().b26(substringBefore(substringAfterLast(string, _Char___init__impl__6a9atx(91)), _Char___init__impl__6a9atx(93)));
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance).b1m();
          tmp_0 = offsetAt(tmp_1, tmp$ret$1);
        } else if (charCodeAt(string, dateTimeFinishedIndex) === _Char___init__impl__6a9atx(90)) {
          tmp_0 = Companion_getInstance_0().i26_1;
        } else {
          tmp_0 = Companion_getInstance_0().j26(substring(string, dateTimeFinishedIndex, string.length));
        }
        return new (OffsetDateTime())(tmp, tmp_0);
      }
      k2a() {
        return OffsetDateTimeIso8601Serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var OffsetDateTimeClass;
function OffsetDateTime() {
  if (OffsetDateTimeClass === VOID) {
    class $ {
      constructor(dateTime, offset) {
        this.r3n_1 = dateTime;
        this.s3n_1 = offset;
      }
      t3n(other) {
        return this.fv().w26(other.fv());
      }
      d(other) {
        return this.t3n(other instanceof OffsetDateTime() ? other : THROW_CCE());
      }
      toString() {
        return this.r3n_1.toString() + this.s3n_1.toString();
      }
      fv() {
        return toInstant(this.r3n_1, this.s3n_1);
      }
      hashCode() {
        var result = this.r3n_1.hashCode();
        result = imul(result, 31) + this.s3n_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OffsetDateTime()))
          return false;
        if (!this.r3n_1.equals(other.r3n_1))
          return false;
        if (!this.s3n_1.equals(other.s3n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OffsetDateTime', VOID, VOID, [Comparable()], VOID, VOID, {0: OffsetDateTimeIso8601Serializer_getInstance});
    OffsetDateTimeClass = $;
  }
  return OffsetDateTimeClass;
}
var OffsetDateTimeIso8601SerializerClass;
function OffsetDateTimeIso8601Serializer() {
  if (OffsetDateTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        OffsetDateTimeIso8601Serializer_instance = this;
        this.u3n_1 = PrimitiveSerialDescriptor('com.lightningkite.OffsetDateTime', STRING_getInstance());
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_instance_0.xw(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      az() {
        return this.u3n_1;
      }
      v3n(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.v3n(encoder, value instanceof OffsetDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'OffsetDateTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    OffsetDateTimeIso8601SerializerClass = $;
  }
  return OffsetDateTimeIso8601SerializerClass;
}
var OffsetDateTimeIso8601Serializer_instance;
function OffsetDateTimeIso8601Serializer_getInstance() {
  if (OffsetDateTimeIso8601Serializer_instance === VOID)
    new (OffsetDateTimeIso8601Serializer())();
  return OffsetDateTimeIso8601Serializer_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      xw(string) {
        // Inline function 'kotlin.charArrayOf' call
        var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(90), _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(43), _Char___init__impl__6a9atx(45)]);
        var dateTimeFinishedIndex = indexOfAny(string, tmp$ret$0, 14);
        if (dateTimeFinishedIndex === -1)
          dateTimeFinishedIndex = string.length;
        return new (ZonedDateTime())(Companion_getInstance().q25(substring(string, 0, dateTimeFinishedIndex)), dateTimeFinishedIndex === string.length ? Companion_getInstance_1().a26_1 : contains(string, _Char___init__impl__6a9atx(91)) ? Companion_getInstance_1().b26(substringBefore(substringAfterLast(string, _Char___init__impl__6a9atx(91)), _Char___init__impl__6a9atx(93))) : charCodeAt(string, dateTimeFinishedIndex) === _Char___init__impl__6a9atx(90) ? Companion_getInstance_1().a26_1 : FixedOffsetTimeZone().d1p(Companion_getInstance_0().j26(substring(string, dateTimeFinishedIndex, string.length))));
      }
      k2a() {
        return ZonedDateTimeIso8601Serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
var ZonedDateTimeClass;
function ZonedDateTime() {
  if (ZonedDateTimeClass === VOID) {
    class $ {
      constructor(dateTime, zone) {
        this.w3n_1 = dateTime;
        this.x3n_1 = zone;
      }
      y3n(other) {
        return this.fv().w26(other.fv());
      }
      d(other) {
        return this.y3n(other instanceof ZonedDateTime() ? other : THROW_CCE());
      }
      toString() {
        return this.w3n_1.toString() + offsetAt(this.x3n_1, toInstant_0(this.w3n_1, this.x3n_1)).toString() + '[' + this.x3n_1.e26() + ']';
      }
      fv() {
        return toInstant_0(this.w3n_1, this.x3n_1);
      }
      hashCode() {
        var result = this.w3n_1.hashCode();
        result = imul(result, 31) + this.x3n_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ZonedDateTime()))
          return false;
        if (!this.w3n_1.equals(other.w3n_1))
          return false;
        if (!this.x3n_1.equals(other.x3n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ZonedDateTime', VOID, VOID, [Comparable()], VOID, VOID, {0: ZonedDateTimeIso8601Serializer_getInstance});
    ZonedDateTimeClass = $;
  }
  return ZonedDateTimeClass;
}
var ZonedDateTimeIso8601SerializerClass;
function ZonedDateTimeIso8601Serializer() {
  if (ZonedDateTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        ZonedDateTimeIso8601Serializer_instance = this;
        this.z3n_1 = PrimitiveSerialDescriptor('com.lightningkite.ZonedDateTime', STRING_getInstance());
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_instance_1.xw(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      az() {
        return this.z3n_1;
      }
      a3o(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.a3o(encoder, value instanceof ZonedDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ZonedDateTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    ZonedDateTimeIso8601SerializerClass = $;
  }
  return ZonedDateTimeIso8601SerializerClass;
}
var ZonedDateTimeIso8601Serializer_instance;
function ZonedDateTimeIso8601Serializer_getInstance() {
  if (ZonedDateTimeIso8601Serializer_instance === VOID)
    new (ZonedDateTimeIso8601Serializer())();
  return ZonedDateTimeIso8601Serializer_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_1 = new (Companion_0())();
//endregion
//region block: exports
export {
  OffsetDateTime as OffsetDateTime38eu0aw2k27kp,
  ZonedDateTime as ZonedDateTime2r72nac52vno4,
  Companion_instance_0 as Companion_instancevghyayl33eva,
  OffsetDateTimeIso8601Serializer_getInstance as OffsetDateTimeIso8601Serializer_getInstance3knxddo24n2p4,
  Companion_instance_1 as Companion_instance2ohraxbyim7rf,
  ZonedDateTimeIso8601Serializer_getInstance as ZonedDateTimeIso8601Serializer_getInstance3j594qymepbka,
};
//endregion

//# sourceMappingURL=ZonedDateTime.mjs.map
